// Dependencies
import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form';
// Components from Dependency
import { FileValidated } from "@dropzone-ui/react";
import {PdfDropZone} from './PdfDropZone';
import {PdfsSizeBar} from './pdfsProgressBar/PdfsSizeBar';

// Utils
import {getTotalFilesSize} from '../../../helpers/getTotalFileSize';

interface PropTypes {
  formValue: string,
  MAX_FILES_SIZE: number;
}

//Este componente contiene la lógica para hacer un dropZone de archivos pdfs, 
//NOTA: cuando se llame debe de tener un form Context de react-hook-form con un valor en los default y con un [] para que no se detenga la app 
//con formValue se le pasa el valor del campo del formulario que se va a actualizar
//con MAX_FILES_SIZE se le pasa el tamaño máximo en MB que se puede subir 
const PdfsDropZoneComponent = ({formValue, MAX_FILES_SIZE}: PropTypes ) => {
  const [totalSize, setTotalSize] = useState<number>((0/MAX_FILES_SIZE)*100);
  
  const {setValue, getValues} = useFormContext();

  //Para cuando se suben los archivos, si se agrega un archivo con un mismo nombre lo sustituye por el nuevo.
  const updateFiles = (incomingFiles: FileValidated[]) => {
    const existingFiles = [...getValues(formValue)]
    const uniqueFiles: FileValidated[] = existingFiles.filter((file) => {
      const fileExists = incomingFiles.find((f) => f.file.name === file.file.name);
      return !fileExists;
    });
    const newFiles: FileValidated[] = [...uniqueFiles, ...incomingFiles];
    setTotalSize((getTotalFilesSize(newFiles)/MAX_FILES_SIZE)*100);
    setValue(formValue, newFiles);
  };

  //Para cuando se borra un archivo
  const onDelete = (fileId: string | number | undefined) => {
    const existingFiles = [...getValues(formValue)]
    const newFiles = existingFiles.filter((x: FileValidated) => x.id !== fileId);
    setTotalSize((getTotalFilesSize(newFiles)/MAX_FILES_SIZE)*100);
    setValue(formValue, newFiles);
  };

  useEffect(() => {
    if(getValues(formValue).length === 0){
      setTotalSize(0);
    }// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getValues(formValue)])

  return (
    <>
      <PdfsSizeBar totalSize={totalSize} />
      <PdfDropZone updateFiles={updateFiles} onDelete={onDelete} formValue={formValue} />              
    </>
  )
}

export {PdfsDropZoneComponent}